import {
    defaultIdAttribute,
    defaultMergeStrategy,
    defaultProcessStrategy,
} from '/b2b/common/helpers/Normalizr';
import { entityName, idAttribute } from './DataStoreProvider.constants';

import Agent from '../agent/DataStoreAgent.schema';
import { schema } from 'normalizr';

export { entityName, idAttribute } from './DataStoreProvider.constants';

export const mergeStrategy = defaultMergeStrategy(idAttribute);
export const processStrategy = defaultProcessStrategy(
    idAttribute,
    function (details, parent, parentKey) {
        if (parentKey !== null && parentKey === 'provider') {
            // Has an agent defined
            const agentId = Agent.getId(parent);
            const currentAgents = details.agents || [];
            if (!currentAgents.includes(agentId)) {
                details.agents = [...currentAgents, agentId];
            }
        }
        return details;
    }
);

export default new schema.Entity(entityName, undefined, {
    idAttribute: defaultIdAttribute(idAttribute),
    mergeStrategy,
    processStrategy,
});
